import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotifyService, SaleService, PrintService, SalePrintData } from '@app/core';
import { MaterialModule } from '../../../material.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as nunjucks from 'nunjucks';

@Component({
  selector: 'ns-sale-print',
  templateUrl: './sale-print.component.html',
  styleUrls: ['./sale-print.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule, MaterialModule],
})
export class SalePrintComponent implements OnInit, OnDestroy {
  htmlTemplate = "<!DOCTYPE html><html lang=\"{{ language }}\"><head><meta charset=\"UTF-8\"><meta name=\"viewport\" content=\"width=device-width,initial-scale=1\"><link href=\"https://fonts.googleapis.com/css2?family=Fira+Mono:wght@400;700&display=swap\" rel=\"stylesheet\"><style>body {\r\n        width: 100%;\r\n      }\r\n      .invoice {\r\n        font-family: 'Fira Mono', monospace;\r\n        font-size: 3mm;\r\n        width: 100%;\r\n        max-width: 210mm;\r\n        margin: 0 auto;\r\n        padding: 5mm;\r\n        box-sizing: border-box;\r\n\r\n        p {\r\n          line-height: 4.2mm;\r\n          margin: 0;\r\n          padding: 0;\r\n        }\r\n\r\n        .sp-1 {\r\n          margin-top: 1mm;\r\n        }\r\n\r\n        .sp-2 {\r\n          margin-top: 2mm;\r\n        }\r\n\r\n        .sp-3 {\r\n          margin-top: 3mm;\r\n        }\r\n\r\n        .txt-medium {\r\n          font-size: 3.5mm;\r\n        }\r\n\r\n        .txt-large {\r\n          font-size: 4mm;\r\n        }\r\n\r\n        .strikethrough {\r\n          text-decoration: line-through;\r\n        }\r\n\r\n        .tab-1 {\r\n          margin-left: 3mm;\r\n        }\r\n\r\n        .two-columns {\r\n          display: flex;\r\n          justify-content: space-between;\r\n        }\r\n\r\n        .two-columns :first-child {\r\n          text-align: left;\r\n        }\r\n\r\n        .two-columns :last-child {\r\n          text-align: right;\r\n        }\r\n\r\n        h1 {\r\n          text-align: center;\r\n          margin: 0;\r\n          padding: 0.14 0;\r\n        }\r\n        .header {\r\n          margin-top: 4mm;\r\n          text-align: center;\r\n        }\r\n        .footer {\r\n          text-align: center;\r\n          margin-bottom: 4mm;\r\n        }\r\n        .header {\r\n        }\r\n        .footer {\r\n        }\r\n        .details {\r\n        }\r\n\r\n        .details .item {\r\n          display: flex;\r\n          justify-content: space-between;\r\n        }\r\n        .details .item:last-child {\r\n        }\r\n\r\n        @media (min-width: 110mm) {\r\n          .invoice {\r\n            width: 100%;\r\n          }\r\n          .details .item {\r\n            grid-template-columns: repeat(4, 1fr);\r\n          }\r\n        }\r\n\r\n        .totals .total-row {\r\n          display: flex;\r\n          justify-content: space-between;\r\n        }\r\n        .total-label {\r\n          text-align: left;\r\n        }\r\n        .total-value {\r\n          text-align: right;\r\n          font-weight: bold;\r\n        }\r\n        .logo {\r\n          text-align: center;\r\n          margin-bottom: 5mm;\r\n        }\r\n        .logo img {\r\n          width: 100%;\r\n          max-width: 60mm;\r\n          height: auto;\r\n        }\r\n        .qr-code {\r\n          text-align: center;\r\n        }\r\n        .qr-code img {\r\n          width: 100%;\r\n          max-width: 2.5cm;\r\n          height: auto;\r\n        }\r\n        hr {\r\n          border: 0;\r\n          border-top: 0.26mm dashed black;\r\n          margin: 1mm 0;\r\n        }\r\n\r\n        .legends {\r\n          .legend {\r\n            margin-bottom: 1mm;\r\n          }\r\n          .legend:last-child {\r\n            margin-bottom: 0;\r\n          }\r\n        }\r\n      }</style></head><body><div class=\"invoice\"><div class=\"header\">{% if store_logo_url %}<div class=\"logo\"><img src=\"{{ store_logo_url }}\" alt=\"Company Logo\"></div>{% endif %}<p class=\"txt-large\"><strong>{{ store_name | uppercase }}</strong></p><p>{{ store_address }}</p><p>RUC: {{ store_id_number }}</p><p><strong>{{ invoice_label | capitalize }}</strong></p><p><strong>{{ invoice_number }}</strong></p><p>Fecha de emisión: {{ invoice_issue_date }}</p></div><div class=\"details sp-3\">{% if customer_name %}<p><strong>Cliente:</strong> {{ customer_name | uppercase }}</p><p><strong>{{ customer_document_type }}:</strong> {{ customer_document_number }}</p>{% if customer_address %}<p><strong>Dirección:</strong> {{ customer_address }}</p>{% endif %} {% endif %}<hr><div class=\"items\">{% for item in items %}<div class=\"item\"><div><span>{{ item.description }}</span><p class=\"tab-1\">{{ item.quantity }} X {{ item.unit_price | currency(locale, currency_code) }} {% if item.discount_percentage %} Desct. {{ item.discount_percentage | round(2) }}% ({{ item.unit_discount | currency(locale, currency_code) }}) {% endif %}</p>{% if item.note %}<p class=\"tab-1\">Nota: {{ item.note }}</p>{% endif %}</div><div><span>{{ item.total_price | currency(locale, currency_code) }}</span> {% if item.discount_percentage %}<p class=\"strikethrough\">{{ item.total_base_price | currency(locale, currency_code) }}</p>{% endif %}</div></div>{% endfor %}</div><hr><div class=\"payments\">{% for item in payments %}<div class=\"item\"><span>{{ item.name }}</span> <span>{{ item.amount | currency(locale, currency_code) }}</span> {% if item.change %} <span>Vuelto: {{ item.change | currency(locale, currency_code) }}</span> {% endif %}</div>{% endfor %}</div><hr>{% if note %}<p><strong>Nota:</strong> {{ note }}</p>{% endif %}<div class=\"totals sp-3\"><div class=\"total-row\"><span class=\"total-label\">Subtotal</span> <span class=\"total-value\">{{ subtotal | currency(locale, currency_code) }}</span></div>{% if exempt %}<div class=\"total-row\"><span class=\"total-label\">Exonerado</span> <span class=\"total-value\">{{ exempt | currency(locale, currency_code) }}</span></div>{% endif %} {% if non_taxable %}<div class=\"total-row\"><span class=\"total-label\">Inafecto</span> <span class=\"total-value\">{{ non_taxable | currency(locale, currency_code) }}</span></div>{% endif %}<div class=\"total-row\"><span class=\"total-label\">IGV ({{ vat_rate | default(0) }}%)</span> <span class=\"total-value\">{{ vat | currency(locale, currency_code) }}</span></div><hr><div class=\"total-row txt-large\"><span class=\"total-label\"><strong>Total</strong></span> <span class=\"total-value\">{{ total | currency(locale, currency_code) }}</span></div></div></div><div class=\"legends sp-3\">{% for legend in legends %}<p class=\"legend\">{{ legend | safe }}</p>{% endfor %}</div>{% if invoice_qr_code_url %}<div class=\"qr-code sp-3\"><img src=\"{{ invoice_qr_code_url }}\" alt=\"QR Code\"></div>{% endif %}<div class=\"footer sp-3\"><p>{{ footer }}</p></div></div></body></html>";
  safeHtml: SafeHtml = '';
  private contentObserver: MutationObserver;
  private contentRendered = false;

  env: nunjucks.Environment;

  data: SalePrintData;
  saleId: string;

  // Obtener referencia al contenedor HTML donde se inyecta el contenido
  @ViewChild('contentContainer', { static: false }) contentContainer: ElementRef;

  constructor(
    route: ActivatedRoute,
    private saleService: SaleService,
    private printService: PrintService,
    private sanitizer: DomSanitizer,
    private notify: NotifyService
  ) {
    this.saleId = route.snapshot.params['sale_id'];
  }

  ngOnInit() {
    // Initialize Nunjucks
    this.initNunjucks();

    this.saleService.data(this.saleId).subscribe((response) => {
      if (response.ok) {
        this.data = response.data!!;

        // Check if the logo is in cache
        if (this.data.store_logo_url) {
          this.getLogoFromCache(this.data.store_logo_url).then(
            (logo) => {
              this.data.store_logo_url = logo; // Update the URL with the cached or downloaded logo
              this.renderTemplate(this.data);
            },
            (error) => {
              console.error('Error getting logo:', error);
              this.renderTemplate(this.data);
            }
          );
        } else {
          this.renderTemplate(this.data);
        }
      } else {
        this.notify.error(response);
      }
    });

    // Create a MutationObserver to observe changes in the DOM
    this.contentObserver = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        if (!this.contentRendered && this.isContentRendered()) {
          this.contentRendered = true;
          this.printService.onDataReady();
        }
      });
    });
  }

  ngAfterViewInit(): void {
    // Start observing the content container
    if (this.contentContainer) {
      this.contentObserver.observe(this.contentContainer.nativeElement, {
        childList: true, // Observe when child nodes are added or removed
        subtree: false, // Observe within all levels of the DOM
      });
    }
  }

  isContentRendered(): boolean {
    // Check if the container has HTML content
    const container = this.contentContainer.nativeElement;
    return container && container.innerHTML.trim().length > 0;
  }

  // Initialize Nunjucks
  initNunjucks(): void {
    // Configurar Nunjucks
    this.env = new nunjucks.Environment(/* Configuración */);

    // Crear el filtro para formatear números como moneda
    this.env.addFilter('currency', function (number, locale = 'en-US', currency = 'USD') {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      }).format(number ?? 0);
    });

    // Add uppercase filter
    this.env.addFilter('uppercase', function (text) {
      return text?.toUpperCase() ?? '';
    });

    // Definir el filtro para redondear
    this.env.addFilter('round', function (value, decimalPlaces = 2) {
      const factor = Math.pow(10, decimalPlaces);
      return Math.round((value ?? 0) * factor) / factor;
    });

    // Crea un filtro personalizado para convertir texto en SVG QR Code
    // this.env.addFilter('qrcode', function (text) {
    //   try {
    //     // Genera el código QR en formato SVG
    //     const qr_svg = qr.imageSync(text, { type: 'svg', ec_level: 'Q' });

    //     // Devuelve el SVG como una cadena
    //     return qr_svg.toString();
    //   } catch (error) {
    //     // Manejo de errores
    //     console.error('Error generating QR code:', error);
    //     return '';
    //   }
    // });
  }

  // Render the template with the provided data
  renderTemplate(data: SalePrintData): void {
    this.env.renderString(this.htmlTemplate, data, (err, res) => {
      if (err) {
        console.error('Error rendering template:', err);
      } else {
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(res!!);
        // this.printService.onDataReady();
      }
    });
  }

  // Función para obtener el logo del caché o descargarlo si no está en caché, con manejo de errores
  async getLogoFromCache(url: string): Promise<string> {
    const cachedLogo = localStorage.getItem('logo');
    if (cachedLogo) {
      return cachedLogo; // Devolver logo desde caché
    }

    try {
      // Intentar descargar la imagen
      const response = await fetch(url);

      // Verificar si la descarga fue exitosa (HTTP 200)
      if (!response.ok) {
        throw new Error(`Error al descargar el logo: ${response.status} ${response.statusText}`);
      }

      // Convertir la respuesta en un Blob
      const blob = await response.blob();

      // Usar FileReader para convertir el Blob en Base64
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onloadend = () => {
          const base64data = reader.result as string;

          // Almacenar el logo en localStorage
          localStorage.setItem('logo', base64data);
          resolve(base64data);
        };

        reader.onerror = () => {
          reject(new Error('Error al convertir la imagen a base64'));
        };

        reader.readAsDataURL(blob); // Convertir el Blob a Base64
      });
    } catch (error) {
      // Si hay algún error en la red o al descargar, manejarlo aquí
      console.error('Error al obtener el logo:', error);
      return Promise.reject(error); // Devolver la promesa rechazada con el error
    }
  }

  ngOnDestroy(): void {
    // Detener la observación cuando el componente se destruye
    if (this.contentObserver) {
      this.contentObserver.disconnect();
    }
  }
}
